import { motion, useScroll, useSpring, useReducedMotion } from 'framer-motion';

/**
 * Thin gold progress line fixed to the top of the page showing scroll depth.
 * Hidden entirely when the visitor prefers reduced motion.
 */
export default function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const reduceMotion = useReducedMotion();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });

  if (reduceMotion) return null;

  return (
    <motion.div
      aria-hidden="true"
      style={{ scaleX, originX: 0 }}
      className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-gradient-to-r from-accent/70 via-accent to-accent/70 pointer-events-none"
    />
  );
}
